import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import LANGUAGES from './consts/languages';

const config = {
    fallbackLng: LANGUAGES.RU,
    supportedLngs: [
        LANGUAGES.EN,
        LANGUAGES.RU,
    ],
    ns: [
        'translation', 
        'auth',
    ],
    debug: process.env.NODE_ENV !== 'production',
    detection: {
        order: ['queryString', 'cookie'],
        cache: ['cookie'],
    },
    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: `${process.env.REACT_APP_TRANSLATION_URL}/{{lng}}/{{ns}}.json`,
    }
};
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(config);

export default i18n;